module.exports = __webpack_public_path__ + "img/Potato.1caa0f1d.svg";